import React from "react";

const C = { cobalt: "#1D4ED8", sky: "#3B82F6", navy: "#0A1628" };

export const VelocityMark = ({ size = 40, dark = false }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
    <rect width="64" height="64" rx="16" fill={dark ? "#fff" : C.navy} />
    <g transform="skewX(-12) translate(7 0)">
      <rect x="14" y="20" width="30" height="7" rx="1.5" fill={C.cobalt} />
      <rect x="10" y="30" width="34" height="7" rx="1.5" fill={dark ? C.navy : "#fff"} />
      <rect x="6" y="40" width="22" height="7" rx="1.5" fill={C.sky} />
    </g>
  </svg>
);

export const MonogramMark = ({ size = 40, dark = false }) => {
  const ink = dark ? "#fff" : C.navy;
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
      <circle cx="32" cy="32" r="28" fill="none" stroke={ink} strokeWidth="4.5" />
      <rect x="16" y="18" width="26" height="6" rx="1" fill={C.cobalt} />
      <rect x="24" y="18" width="6" height="29" rx="1" fill={ink} />
      <path d="M30 27.5 H38 a7 7 0 0 1 0 14 H30" fill="none" stroke={ink} strokeWidth="5.5" strokeLinejoin="round" />
    </svg>
  );
};

export const BreakawayMark = ({ size = 40, dark = false }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
    <polygon points="6,56 20,56 38,10 24,10" fill={dark ? "#fff" : C.navy} />
    <polygon points="24,56 38,56 50,26 36,26" fill={C.cobalt} />
    <circle cx="51" cy="13" r="7" fill={C.sky} />
  </svg>
);

const WordVelocity = ({ dark, className = "" }) => (
  <span className={`otp-display italic uppercase ${className}`} style={{ color: dark ? "#fff" : C.navy, letterSpacing: "-0.04em" }}>
    ONTHE<span style={{ color: dark ? C.sky : C.cobalt }}>PITCH</span>
  </span>
);

const WordMonogram = ({ dark, className = "" }) => (
  <span className={`font-geist font-semibold uppercase ${className}`} style={{ color: dark ? "#fff" : C.navy, letterSpacing: "0.22em" }}>
    Onthepitch
  </span>
);

const WordBreakaway = ({ dark, className = "" }) => (
  <span className={`font-geist font-extrabold lowercase ${className}`} style={{ color: dark ? "#fff" : C.navy, letterSpacing: "-0.05em" }}>
    onthepitch<span style={{ color: C.cobalt }}>.</span>
  </span>
);

export const LOGOS = {
  velocity: { name: "Velocity", Mark: VelocityMark, Word: WordVelocity, idea: "Three forward-skewed speed bars — acceleration, progression, momentum. Italic heavy wordmark with PITCH in cobalt. Loud, athletic, campaign-ready." },
  monogram: { name: "OTP Crest", Mark: MonogramMark, Word: WordMonogram, idea: "O, T and P locked into one circular crest — a seal of trust. Wide-tracked wordmark feels like a premium American institution. Calm, credible, timeless." },
  breakaway: { name: "Breakaway", Mark: BreakawayMark, Word: WordBreakaway, idea: "Two lanes surging upward with an athlete breaking through the line. Lowercase wordmark with a cobalt dot — friendly, modern, tech-company DNA." },
};

export const Logo = ({ variant = "velocity", dark = false, size = 34, textClass = "text-xl" }) => {
  const { Mark, Word } = LOGOS[variant];
  return (
    <span className="inline-flex items-center gap-2.5" data-testid={`logo-${variant}`}>
      <Mark size={size} dark={dark} />
      <Word dark={dark} className={textClass} />
    </span>
  );
};
